import React from 'react';
import _ from 'underscore';

import {MODEL_NAMES} from 'results/ResultsNamingConstants';
import RadioButtonGroup from 'ui-library/inputs/RadioButtonGroup';

import {DATA_TYPE, FieldsChainField} from './LookupConfigurationUtil';

function getSelectedFieldsLabel(fieldsChain: Array<FieldsChainField>): string {
  if (fieldsChain.length === 0) {
    return 'Sample ID';
  }

  // eslint-disable-next-line no-restricted-syntax
  const fieldsChainDisplay = _.pluck(fieldsChain, 'name').reverse().join(' \u2192 ');
  return `${fieldsChainDisplay} ID`;
}

interface LookupFieldDataTypeSelectorProps {
  dataType: DATA_TYPE;
  isStageRunInput: boolean;
  fieldsChain: Array<FieldsChainField>;
  onDataTypeChanged: (dataType: DATA_TYPE) => void;
}
export function LookupFieldDataTypeSelector(props: LookupFieldDataTypeSelectorProps): JSX.Element {
  const {dataType, isStageRunInput, fieldsChain, onDataTypeChanged} = props;
  const isInputSampleSelectionAllowed = isStageRunInput && fieldsChain.length === 0;
  return (
    <RadioButtonGroup
      title="Insert"
      selectedValue={dataType}
      options={_.compact([
        {value: DATA_TYPE.DATA_TABLE, label: `${MODEL_NAMES.Result_table} field`},
        {value: DATA_TYPE.SCHEMA_FIELD, label: 'Schema field'},
        isInputSampleSelectionAllowed
          ? {
              value: DATA_TYPE.INPUT_SAMPLE,
              label: 'Input sample',
            }
          : {
              value: DATA_TYPE.SAMPLE_ID,
              label: getSelectedFieldsLabel(fieldsChain),
            },
      ])}
      onChange={onDataTypeChanged}
    />
  );
}

export default LookupFieldDataTypeSelector;
